import "jquery"
import { fromEvent, Subscription } from "rxjs";

export class WizardForm {

    get _radioButtons() {
        return $(".radio-group .radio");
    }

    get _previousButton() {
        return $(`${this._options.previousButton}`);
    }

    get _nextButton() {
        return $(`${this._options.nextButton}`)
    }

    /** @type {{ id: string, previousButton: string, nextButton: string, onLeaveStep: (stepNumber: number, operation: "next" | "previous", button: JQuery<HTMLElement>) => Promise<boolean> }} */
    _options = null;

    /** @type { JQuery<HTMLElement> }*/
    current_fs = null;

    /** @type { JQuery<HTMLElement> }*/
    next_fs = null;

    /** @type { JQuery<HTMLElement> }*/
    previous_fs = null;

    /** @type {number} */
    _opacity;

    /** @type {Subscription} */
    _nextSub;

    /** @type {Subscription} */
    _previousSub;

    /**
     * 
     * @param {{ id: string, previousButton: string, nextButton: string, onLeaveStep: (stepNumber: number, operation: "next" | "previous", button: JQuery<HTMLElement>) => Promise<boolean> }} options
     */
    constructor(options) {
        this._options = options   
    }

    /**
     * 
     * @param {number} stepNumber
     */
    init(stepNumber) {
        this.bindWizardNext();
        this.bindWizardPrevious();

        this._radioButtons.on("click", function () {
            $(this).parent().find(".radio").removeClass("selected");
            $(this).addClass("selected");
        });

        this.selectWizardStep(stepNumber);
    }

    /**
     * 
     * @param {number} stepNumber
     */
    selectWizardStep(stepNumber) {
        
        if (!stepNumber) {
            return;
        }

        this.current_fs = this._form.find(`fieldset[data-step="1"]`)
        this.next_fs = this._form.find(`fieldset[data-step="${stepNumber}"]`)

        if (!this.next_fs.is("[allow-load]")) {
            return;
        }

        // active previous fields
        for (var i = stepNumber - 1; i >= 1; i--) {
            $("#progressbar li").eq(i).addClass("active");
        }

        $("#progressbar li").removeClass("current-step")
        this._getNextProgressLi.addClass("current-step")

        //show the next fieldset
        this.next_fs.show();
        //hide the current fieldset with style
        this.current_fs.animate(
            { opacity: 0 },
            {
                step: (now) => {
                    // for making fielset appear animation
                    this.opacity = 1 - now;

                    this.current_fs.css({
                        display: "none",
                        position: "relative",
                    });
                    this.next_fs.css({ opacity: this.opacity });
                },
                duration: 600,
            }
        );

    }

    bindWizardNext() {
        this._nextSub?.unsubscribe();
        this._nextSub = fromEvent(this._nextButton, "click").subscribe(async e => {
            const currentElement = $(e.currentTarget);
            let step = currentElement.data("step");

            if (step <= -1) {
                return;
            }

            if (step) {
                this.current_fs = this._form.find(`#form-step-${step}`)
                this.next_fs = this._form.find(`#form-step-${step + 1}`)
            }
            else {
                this.current_fs = currentElement.parent();
                this.next_fs = currentElement.parent().next();
            }

            let stepNumber = this.current_fs.data("step");

            let nexting = await this._options.onLeaveStep(stepNumber, "next", currentElement);
            if (nexting) {

                //Add Class Active
                this._getNextProgressLi.addClass("active");

                // Add Class current-step
                $("#progressbar li").removeClass("current-step")
                this._getNextProgressLi.addClass("current-step")

                //show the next fieldset
                this.next_fs.show();
                //hide the current fieldset with style
                this.current_fs.animate(
                    { opacity: 0 },
                    {
                        step: (now) => {
                            // for making fielset appear animation
                            this.opacity = 1 - now;

                            this.current_fs.css({
                                display: "none",
                                position: "relative",
                            });
                            this.next_fs.css({ opacity: this.opacity });
                        },
                        duration: 600,
                    }
                );
            }
            else {
                currentElement.trigger("blur")
            }

            $('html, body').animate({ scrollTop: 0 }, 'slow')
        })
    }

    bindWizardPrevious() {
        this._previousSub?.unsubscribe();
        this._previousSub = fromEvent(this._previousButton, "click").subscribe(async e => {
            const currentElement = $(e.currentTarget);
            let step = currentElement.data("step");

            if (step <= -1) {
                return;
            }

            if (step) {
                this.current_fs = this._form.find(`#form-step-${step}`)
                this.previous_fs = this._form.find(`#form-step-${step - 1}`)
            }
            else {
                this.current_fs = currentElement.parent();
                this.previous_fs = currentElement.parent().prev();
            }

            let stepNumber = this.current_fs.data("step");

            let nexting = await this._options.onLeaveStep(stepNumber, "previous", currentElement);
            if (nexting) {
                //Remove class active
                this._getCurrentProgressLi.removeClass("active");

                // add class current-step
                $("#progressbar li").removeClass("current-step")
                this._getPreviousProgressLi.addClass("current-step")

                //show the previous fieldset
                this.previous_fs.show();

                //hide the current fieldset with style
                this.current_fs.animate(
                    { opacity: 0 },
                    {
                        step: (now) => {
                            // for making fielset appear animation
                            this.opacity = 1 - now;

                            this.current_fs.css({
                                display: "none",
                                position: "relative",
                            });
                            this.previous_fs.css({ opacity: this.opacity });
                        },
                        duration: 600,
                    }
                );
            }
            else {
                currentElement.trigger("blur")
            }

            $('html, body').animate({ scrollTop: 0 }, 'slow')
        })
    }

    /**
     * 
     * @param {number} step 
     * @param {"next" | "previous"} operation
     */
    skipStep(step, operation) {
        if (step <= -1) {
            return;
        }

        if (operation === "next") {

            this.current_fs = this._form.find(`fieldset[data-step="${step}"]`)
            this.next_fs = this._form.find(`fieldset[data-step="${step + 1}"]`)

            //Add Class Active
            this._getNextProgressLi.addClass("active");

            $("#progressbar li").removeClass("current-step")
            this._getNextProgressLi.addClass("current-step")

            //show the next fieldset
            this.next_fs.show();
            //hide the current fieldset with style
            this.current_fs.animate(
                { opacity: 0 },
                {
                    step: (now) => {
                        // for making fielset appear animation
                        this.opacity = 1 - now;

                        this.current_fs.css({
                            display: "none",
                            position: "relative",
                        });
                        this.next_fs.css({ opacity: this.opacity });
                    },
                    duration: 600,
                }
            );
            $('html, body').animate({ scrollTop: 0 }, 'slow')
        }

        if (operation === "previous") {

            this.current_fs = this._form.find(`fieldset[data-step="${step}"]`)
            this.previous_fs = this._form.find(`fieldset[data-step="${step - 1}"]`)

            //Remove class active
            this._getCurrentProgressLi.removeClass("active");

            $("#progressbar li").removeClass("current-step")
            this._getPreviousProgressLi.addClass("current-step")

            //show the previous fieldset
            this.previous_fs.show();

            //hide the current fieldset with style
            this.current_fs.animate(
                { opacity: 0 },
                {
                    step: (now) => {
                        // for making fielset appear animation
                        this.opacity = 1 - now;

                        this.current_fs.css({
                            display: "none",
                            position: "relative",
                        });
                        this.previous_fs.css({ opacity: this.opacity });
                    },
                    duration: 600,
                }
            );

            $('html, body').animate({ scrollTop: 0 }, 'slow')
        }
    }

    get _getNextProgressLi() {
        return $("#progressbar li").eq($("fieldset").index(this.next_fs));
    }

    get _getCurrentProgressLi() {
        return $("#progressbar li").eq($("fieldset").index(this.current_fs));
    }

    get _getPreviousProgressLi() {
        return $("#progressbar li").eq($("fieldset").index(this.previous_fs));
    }

    get _form() {
        return $(`${this._options.id}`)
    }
}